import React, { useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Tabs, Tab, Paper } from '@mui/material';
import {
  BarChart as StatsIcon,
  Rule as BrandsIcon,
  Store as RetailersIcon,
} from '@mui/icons-material';

import ExtractionStatsTab from './ExtractionStatsTab';
import BrandsTab from './BrandsTab';
import RetailersTab from './RetailersTab';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`code-extraction-tabpanel-${index}`}
      aria-labelledby={`code-extraction-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

const TAB_PATHS = [
  '/code-extraction',
  '/code-extraction/brands',
  '/code-extraction/retailers',
];

function getTabIndex(pathname) {
  if (pathname.includes('/brands')) return 1;
  if (pathname.includes('/retailers')) return 2;
  return 0;
}

export default function CodeExtractionDashboard() {
  const navigate = useNavigate();
  const location = useLocation();

  const tabValue = useMemo(() => getTabIndex(location.pathname), [location.pathname]);

  const handleTabChange = (event, newValue) => {
    navigate(TAB_PATHS[newValue], { replace: true });
  };

  return (
    <Box>
      <Paper sx={{ mb: 2 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab icon={<StatsIcon />} iconPosition="start" label="Overview" />
          <Tab icon={<BrandsIcon />} iconPosition="start" label="Brands" />
          <Tab icon={<RetailersIcon />} iconPosition="start" label="Retailers" />
        </Tabs>
      </Paper>

      <TabPanel value={tabValue} index={0}>
        <ExtractionStatsTab />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <BrandsTab />
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <RetailersTab />
      </TabPanel>
    </Box>
  );
}
